module.exports = __webpack_public_path__ + "img/compensation-section-circle-arrow.b29452bb.png";